/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Zotero_Browser_Skipped_Items_CountInputs */

const en_zotero_browser_skipped_items_count = /** @type {(inputs: Zotero_Browser_Skipped_Items_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`1 item skipped`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} items skipped`);
	return /** @type {LocalizedString} */ ("zotero_browser_skipped_items_count");
};

const es_zotero_browser_skipped_items_count = /** @type {(inputs: Zotero_Browser_Skipped_Items_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`1 elemento omitido`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} elementos omitidos`);
	return /** @type {LocalizedString} */ ("zotero_browser_skipped_items_count");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "1 item skipped" |
* | "other" | "{count} items skipped" |
*
* @param {Zotero_Browser_Skipped_Items_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_skipped_items_count = /** @type {((inputs: Zotero_Browser_Skipped_Items_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_Skipped_Items_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_skipped_items_count(inputs)
	return en_zotero_browser_skipped_items_count(inputs)
});